/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_radar_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a radar (spider) chart from pasted data — compare items across metrics, no sign-up.`)
};

const es_radar_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un gráfico de radar (araña) a partir de datos pegados — compara elementos en varias métricas, sin registro.`)
};

const de_radar_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellen Sie ein Radar-(Spinnen-)Diagramm aus eingefügten Daten — vergleichen Sie Elemente über mehrere Kennzahlen, keine Anmeldung erforderlich.`)
};

const nl_radar_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak een radar- (spider-) diagram van geplakte data — vergelijk items over meerdere metrics, geen registratie nodig.`)
};

const fr_radar_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créez un diagramme radar (en araignée) à partir de données collées — comparez des éléments selon plusieurs métriques, sans inscription.`)
};

const it_radar_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un grafico radar (a ragno) dai dati incollati — confronta elementi su più metriche, senza registrazione.`)
};

const pt_br2_radar_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie um gráfico de radar (aranha) a partir de dados colados — compare itens em várias métricas, sem cadastro.`)
};

const pt_radar_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie um gráfico radar (aranha) a partir de dados colados — compare itens em várias métricas, sem registo.`)
};

const ja_radar_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`貼り付けたデータからレーダー（スパイダー）チャートを作成します — 複数の指標にわたって項目を比較、登録不要。`)
};

const zh_radar_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据粘贴的数据创建雷达图（蜘蛛图）——在多个指标上比较不同项目，无需注册。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const radar_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.radar_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("radar_tool_description", locale)
	if (locale === "en") return en_radar_tool_description(inputs)
	if (locale === "es") return es_radar_tool_description(inputs)
	if (locale === "de") return de_radar_tool_description(inputs)
	if (locale === "nl") return nl_radar_tool_description(inputs)
	if (locale === "fr") return fr_radar_tool_description(inputs)
	if (locale === "it") return it_radar_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_radar_tool_description(inputs)
	if (locale === "pt") return pt_radar_tool_description(inputs)
	if (locale === "ja") return ja_radar_tool_description(inputs)
	return zh_radar_tool_description(inputs)
};